var words;

function CroutonLocalization(language) {
	this.language = language;
	this.words = {
		"ar": {
			"days_of_the_week" : ["", "الأحد", "الاثنين", "الثلاثاء", "الأربعاء ", "الخميس", "الجمعة", "السبت"],
			"weekday" : "يوم عمل",
			"city" : "مدينة",
			"cities" : "المدن",
			"groups" : "مجموعات",
			"areas" : "المناطق",
			"regions": "المناطق",
			"locations" : "المواقع",
			"counties" : "المقاطعات",
			"states" : "المقاطعات",
			"postal_codes" : "الرموز البريدية",
			"formats" : "الأشكال",
			"map" : "خريطة",
			"neighborhood": "الحي",
			"near_me": "بالقرب مني",
			"text_search": "البحث عن النص",
			"click_search": "انقر فوق البحث",
			"pan_and_zoom": "عموم + التكبير",
			"languages": "اللغات",
			"common_needs": "الاحتياجات المشتركة",
			"meeting_count": "الاجتماعات الأسبوعية:",
			"venue_types": "أنواع المكان",
			"venue_type_choices": {
				IN_PERSON: "شخصيا",
				VIRTUAL: "افتراضي",
			},
			"service_body_types": {
				AS: "لجنة خدمات المنطق",
				RS: "لجنة خدمات الإقلي.م",
				ZF: "منتدى المنطقة"	,
				MA: "لجنة خدمات العاصمة",
				LS: "خدمة المنتديات المحلية",
				GS: "Group Support Forum",
			},
			"css-direction": 'bmlt-rtl',
			"share": "مشاركة",
			'google_directions': 'اتجاهات جوجل للاجتماع',
			'apple_directions': 'اتجاهات جوجل للاجتماع',
			"no_meetings_for_this_day": "لا توجد اجتماعات لهذا اليوم.",
			'all': 'الجميع',
			'menu': 'القائمة',
			'search for meetings':'البحث عن الاجتماعات',
			'show meetings near...': 'أظهر الاجتماعات بالقرب من...',
			'filter meetings':'سرد الاجتماعات',
			'visible meeting list': 'قائمة الاجتماعات المرئية',
			'enter a city or zip code': 'أدخل المدينة أو الرمز البريدي',
			'toggle fullscreen mode': 'تبديل وضع ملء الشاشة',
			'close': "قريب",
			"bmlt2ics": "Add to your calendar",
			'meeting page': "صفحة الاجتماع",
			'meeting details': "تفاصيل الاجتماع",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"get_directions": "احصل على الاتجاهات",
			"select_map_app": "اختر تطبيق الخرائط",
			"apple_maps": "خرائط آبل",
			"apple_maps_desc": "فتح في تطبيق خرائط آبل",
			"google_maps": "خرائط جوجل",
			"google_maps_desc_mobile": "فتح في تطبيق خرائط جوجل",
			"waze": "وايز",
			"waze_desc": "فتح في تطبيق وايز",
			'address_lookup_fail': 'تعذر العثور على العنوان. يرجى المحاولة مرة أخرى.',
		},
		"cs": {
			"days_of_the_week": ["", "Neděle", "Pondělí", "Úterý", "Středa", "Čtvrtek", "Pátek", "Sobota"],
			"weekday": "Den v týdnu",
			"city": "Město",
			"cities": "Město",
			"groups": "Skupina",
			"areas": "Oblasti",
			"regions": "Regiony",
			"locations": "Místo",
			"counties": "Okres",
			"states": "Spolkové země",
			"postal_codes": "PSČ",
			"formats": "Formáty",
			"map": "Mapa",
			"neighborhood": "Sousedství",
			"near_me": "V mém okolí",
			"text_search": "Textové vyhledávání",
			"click_search": "Vyhledávání kliknutím",
			"pan_and_zoom": "Posunout + Zoom",
			"languages": "Jazyky",
			"common_needs": "Běžné potřeby",
			"meeting_count": "Týdenní setkání:",
			"venue_types": "Druhy míst setkání",
			"venue_type_choices": {
				"IN_PERSON": "Živé setkání",
				"VIRTUAL": "Online setkání"
			},
			"service_body_types": {
			},
			"share": "Sdílet",
			"google_directions": "Plánovač tras Google",
			"apple_directions": "Plánovač tras Apple",
			"no_meetings_for_this_day": "Na tento den nejsou žádná setkání.",
			"css-textalign": "",
			"css-floatdirection": "",
			"all": "Jakékoli",
			"menu": "Menu",
			"search for meetings": "Hledat setkání",
			"show meetings near...": "Setkání v jiných městech",
			"filter meetings": "Filtr pro jazyk, formát atd.",
			"visible meeting list": "Viditelný seznam setkání jako tabulka",
			"enter a city or zip code": "Město nebo PSČ",
			"toggle fullscreen mode": "Přepnout režim celé obrazovky",
			"close": "Zavřít",
			"bmlt2ics": "Přidat do kalendáře",
			"meeting page": "Stránka setkání",
			"meeting details": "Podrobnosti o setkání",
			"report update": "Nahlásit aktualizaci",
			"filter by visibility": "Zobrazit pouze setkání, která jsou aktuálně na mapě",
			"go": "Jít!",
			"get_directions": "Získat pokyny",
			"select_map_app": "Vyberte aplikaci pro mapy",
			"apple_maps": "Apple Mapy",
			"apple_maps_desc": "Otevřít v aplikaci Apple Mapy",
			"google_maps": "Mapy Google",
			"distance": "Vzdálenost",
			"google_maps_desc_mobile": "Otevřít v aplikaci Mapy Google",
			"waze": "Waze",
			"waze_desc": "Otevřít v aplikaci Waze",
			"remember my choice": "Zapamatovat si moji volbu",
			"zoomed-out-message": "Nemůžeme prohledat celou oblast pro setkání. Přibližte si prosím nebo proveďte nové vyhledávání.",
			"sorted by distance": "Seřazeno podle vzdálenosti",
			"address_lookup_fail": "Adresu se nepodařilo najít. Zkuste to prosím znovu.",
		},
		"da-DK": {
			"days_of_the_week": ["", "Søndag", "Mandag", "Tirsdag", "Onsdag", "Torsdag", "Fredag", "Lørdag"],
			"weekday": 'Ugedag',
			"city": "By",
			"cities": "Byer",
			"groups": "Grupper",
			"areas": "Områder",
			"regions": "Regions",
			"locations": "Lokalite",
			"counties": "Amter",
			"states": "Provinser",
			"postal_codes": "Post nummer",
			"formats": "Struktur",
			"map": "Kort",
			"neighborhood": "Neighborhood",
			"near_me": "Find nearby meetings",
			"text_search": "Find meetings there",
			"click_search": "Find meetings near to a point on the map",
			"pan_and_zoom": "Pan + Zoom",
			"languages": "Languages",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			'all': 'All',
			'menu': 'Menu',
			"bmlt2ics": "Add to your calendar",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"distance": "Afstand",
			"get_directions": "Få vejvisning",
			"select_map_app": "Vælg kortapp",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Åbn i Apple Maps app",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Åbn i Google Maps app",
			"waze": "Waze",
			"waze_desc": "Åbn i Waze app",
			"sorted by distance": "Sorteret efter Afstand",
			"address_lookup_fail": "Adressen kunne ikke findes. Prøv venligst igen.",
		},
		"de-DE":{
			"days_of_the_week": ["", "Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
			"weekday": 'Wochentag',
			"city": "Stadt",
			"cities": "Städte",
			"groups": "Gruppen",
			"areas": "Gebiete",
			"regions": "Regions",
			"locations": "Orte",
			"counties": "Landkreise",
			"states": "Bundesländer",
			"postal_codes": "PLZ",
			"formats": "Formate",
			"map": "Karte",
			"neighborhood": "Nachbarschaft",
			"near_me": "In meiner Nähe",
			"text_search": "Textsuche",
			"click_search": "Klicksuche",
			"pan_and_zoom": "Schwenken + Zoomen",
			"languages": "Sprachen",
			"common_needs": "Common Needs",
			"meeting_count": "Wöchentliche Meetings:",
			"venue_types": "Treffpunktarten",
			"venue_type_choices": {
				IN_PERSON: "Präsenz-Meetings",
				VIRTUAL: "Online-Meetings",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "Teilen",
			'google_directions': 'Google Routenplaner',
			'apple_directions': 'Apple Routenplaner',
			"no_meetings_for_this_day": "Keine Meetings an diesem Tag.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'Alle',
			'menu': 'Menu',
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Meetings in andere Städten',
			'filter meetings': 'Filter für Sprache, Format usw.',
			'visible meeting list': 'Sichtbare Meetings als Tabelle',
			'enter a city or zip code': 'Stadt oder PLZ',
			'toggle fullscreen mode': 'Umschalten Vollbildmodus',
			'close': "Schliessen",
			"bmlt2ics": "Zu Kalender hinzufügen",
			'meeting page': "Meeting Seite",
			'meeting details': "Genaueres zum Meeting",
			'report update': "Report an Update",
			'filter by visibility': "Zeige nur Meetings, die gerade auf dem Karte stehen",
			'go': "Los!",
			"get_directions": "Wegbeschreibung",
			"select_map_app": "Karten-App auswählen",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "In Apple Maps App öffnen",
			"google_maps": "Google Maps",
			"distance": "Entfernung",
			"google_maps_desc_mobile": "In Google Maps App öffnen",
			"waze": "Waze",
			"waze_desc": "In Waze App öffnen",
			"remember my choice": "Auswahl speichern",
			"zoomed-out-message": "Wir können nicht die ganze Fläche nach Meetings durchsuchen.  Bitte reinzoomen oder eine neue Suche machen.",
			"sorted by distance": "Sortiert nach Entfernung",
			"address_lookup_fail": "Die Adresse konnte nicht gefunden werden. Bitte versuchen Sie es erneut.",
		},
"en-AU": {
			"days_of_the_week" : ["", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			"weekday" : "Weekday",
			"city" : "City",
			"cities" : "Cities",
			"groups" : "Groups",
			"areas" : "Areas",
			"regions": "Regions",
			"locations" : "Locations",
			"counties" : "Counties",
			"states" : "States",
			"postal_codes" : "Postcodes",
			"formats" : "Formats",
			"map" : "Map",
			"neighborhood": "Neighbourhood",
			"near_me": "Find nearby meetings",
			"text_search": "Find meetings there",
			"click_search": "Find meetings near to a point on the map",
			"languages": "Languages",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			'google_directions': 'Google directions to meeting',
	        'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			"bmlt2ics": "Add to your calendar",
			'all': 'All',
			'menu': 'Menu',
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city and state',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			'open search dialog': "Open Search Dialog",
			"get_directions": "Get Directions",
			"select_map_app": "Select Map App",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Open in Apple Maps app",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Open in Google Maps app",
			"waze": "Waze",
			"waze_desc": "Open in Waze app",
			"zoomed-out-message": "We can't search the entire area for meetings. Please zoom in or do a new search.",
			"sorted by distance": "Sorted by Distance",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"en-CA": {
			"days_of_the_week" : ["", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			"weekday" : "Weekday",
			"city" : "City",
			"cities" : "Cities",
			"groups" : "Groups",
			"areas" : "Areas",
			"regions": "Regions",
			"locations" : "Locations",
			"counties" : "Counties",
			"states" : "Provinces",
			"postal_codes" : "Postal Codes",
			"formats" : "Formats",
			"map" : "Map",
			"neighborhood": "Neighborhood",
			"near_me": "Find nearby meetings",
			"text_search": "Find meetings there",
			"click_search": "Find meetings near to a point on the map",
			"pan_and_zoom": "Pan + Zoom",
			"languages": "Languages",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': 'Menu',
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			"bmlt2ics": "Add to your calendar",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'open search dialog': "Open Search Dialog",
			'go': "Go!",
			"get_directions": "Get Directions",
			"select_map_app": "Select Map App",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Open in Apple Maps app",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Open in Google Maps app",
			"waze": "Waze",
			"waze_desc": "Open in Waze app",
			"zoomed-out-message": "We can't search the entire area for meetings. Please zoom in or do a new search.",
			"sorted by distance": "Sorted by Distance",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"en-NZ": {
			"days_of_the_week" : ["", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			"weekday" : "Weekday",
			"city" : "City",
			"cities" : "Cities",
			"groups" : "Groups",
			"areas" : "Areas",
			"regions": "Regions",
			"locations" : "Locations",
			"counties" : "Counties",
			"states" : "States",
			"postal_codes" : "Postcodes",
			"formats" : "Formats",
			"map" : "Map",
			"neighborhood": "Neighborhood",
			"near_me": "Find nearby meetings",
			"text_search": "Find meetings there",
			"click_search": "Find meetings near to a point on the map",
			"pan_and_zoom": "Pan + Zoom",
			"languages": "Languages",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': 'Menu',
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			"bmlt2ics": "Add to your calendar",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'open search dialog': "Open Search Dialog",
			'go': "Go!",
			"get_directions": "Get Directions",
			"select_map_app": "Select Map App",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Open in Apple Maps app",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Open in Google Maps app",
			"waze": "Waze",
			"waze_desc": "Open in Waze app",
			"zoomed-out-message": "We can't search the entire area for meetings. Please zoom in or do a new search.",
			"sorted by distance": "Sorted by Distance",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"en-UK": {
			"days_of_the_week" : ["", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			"weekday" : "Weekday",
			"city" : "City",
			"cities" : "Cities",
			"groups" : "Groups",
			"areas" : "Areas",
			"regions": "Regions",
			"locations" : "Locations",
			"counties" : "Counties",
			"states" : "States",
			"postal_codes" : "Postcodes",
			"formats" : "Formats",
			"map" : "Map",
			"neighborhood": "Neighborhood",
			"near_me": "Find nearby meetings",
			"text_search": "Find meetings there",
			"click_search": "Find meetings near to a point on the map",
			"pan_and_zoom": "Pan + Zoom",
			"languages": "Languages",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': "Menu",
			"bmlt2ics": "Add to your calendar",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'open search dialog': "Open Search Dialog",
			'go': "Go!",
			"get_directions": "Get Directions",
			"select_map_app": "Select Map App",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Open in Apple Maps app",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Open in Google Maps app",
			"waze": "Waze",
			"waze_desc": "Open in Waze app",
			"zoomed-out-message": "We can't search the entire area for meetings. Please zoom in or do a new search.",
			"sorted by distance": "Sorted by Distance",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"en-US": {
			"days_of_the_week" : ["", "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			"weekday" : "Weekday",
			"city" : "City",
			"cities" : "Cities",
			"groups" : "Groups",
			"areas" : "Areas",
			"regions": "Regions",
			"locations" : "Locations",
			"counties" : "Counties",
			"states" : "States",
			"postal_codes" : "Zips",
			"formats" : "Formats",
			"map" : "Map",
			"neighborhood": "Neighborhood",
			"near_me": "Find nearby meetings",
			"text_search": "Find meetings there",
			"click_search": "Find meetings near to a point on the map",
			"pan_and_zoom": "Pan + Zoom",
			"languages": "Languages",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': "Menu",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			"bmlt2ics": "Add to your calendar",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'open search dialog': "Open Search Dialog",
			'go': "Go!",
			"get_directions": "Get Directions",
			"select_map_app": "Select Map App",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Open in Apple Maps app",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Open in Google Maps app",
			"waze": "Waze",
			"waze_desc": "Open in Waze app",
			"zoomed-out-message": "We can't search the entire area for meetings. Please zoom in or do a new search.",
			"sorted by distance": "Sorted by Distance",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"es-US": {
    		"days_of_the_week" : ["", "Domingo", " Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
   			"weekday" : "Día de la semana",
   			"city" : "Ciudad",
    		"cities" : "Ciudades",
    		"groups" : "Grupos",
    		"areas" : "Áreas",
    		"regions": "Regiones",
    		"locations" : "Ubicaciones",
    		"counties" : "Provincias",
    		"states" : "Comunidad Autónoma",
    		"postal_codes" : "Códigos postales",
    		"formats" : "Formatos",
    		"map" : "Mapa",
    		"neighborhood": "Distrito",
    		"near_me": "Sitios cercanos",
    		"text_search": "Búsqueda de texto",
    		"click_search": "Buscar en Google",
    		"pan_and_zoom": "Paneo y Zoom",
   			"languages": "Idiomas",
    		"common_needs": "Necesidades comunes",
    		"meeting_count":"Número de reuniones encontradas",
    		"Weekly Meetings": "Reuniones semanales",
    		"venue_types": "Tipos de espacios",
    		"venue_type_choices": {
        		IN_PERSON: "Presencial",
        		VIRTUAL: "Virtual",
    		},
    		"service_body_types": {
        		AS: "Cómite de servicio de Área",
        		RS: "Comité regional de servicio",
        		ZF: "Foro Zonal",
        		MA: "Comité metropolitano de servicio",
        		LS: "Foro de servicio local",
        		GS: "Foro de apoyo a grupos",
    		},
    		"share": "compartir",
    		"no_meetings_for_this_day": "No hay reuniones en este día",
    		'css-textalign': '',
    		'google_directions': 'Indicaciones de Google',
			'apple_directions': 'Indicaciones de Apple',
    		'css-floatdirection': "Dirección float-CSS",
    		'all': 'Todos',
    		'menu': "Menú",
    		'search for meetings': 'Buscar reuniones',
    		'show meetings near...': 'Mostrar reuniones cercanas...',
    		'filter meetings': 'Filtrar reuniones',
    		'visible meeting list': 'Listado visible de reuniones',
    		'enter a city or zip code': 'Introduce una ciudad o un código postal',
    		'toggle fullscreen mode': 'Modo pantalla completa',
    		'close': "Cerrar",
    		"bmlt2ics": "Añadir a calendario",
    		'meeting page': "Página de la reunión",
    		'meeting details': "Detalles de la reunión",
    		'report update': "Actualización de informe",
    		'filter by visibility': "Listar solo estas reuniones",
    		'go': "¡Adelante!",
			"distance": "Distancia",
    		"get_directions": "Obtener Direcciones",
    		"select_map_app": "Seleccionar Aplicación de Mapas",
    		"apple_maps": "Apple Maps",
    		"apple_maps_desc": "Abrir en la aplicación Apple Maps",
    		"google_maps": "Google Maps",
    		"google_maps_desc_mobile": "Abrir en la aplicación Google Maps",
    		"waze": "Waze",
    		"waze_desc": "Abrir en la aplicación Waze",
			"zoomed-out-message": "No podemos buscar reuniones en toda la zona. Por favor, acérquese o haga una nueva búsqueda.",
			"sorted by distance": "Ordenado por distancia",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"fa-IR": {
			"days_of_the_week" : ["", 'یَکشَنب', 'دوشَنبه', 'سه‌شنبه', 'چهار شنبه', 'پَنج شَنبه', 'جُمعه', 'شَنبه'],
			"weekday" : "ایام هفته",
			"city" : "شهر",
			"cities" : "شهرها",
			"groups" : "گروه ها",
			"areas" : "نواحی",
			"regions" : "مناطق",
			"locations" : "آدرسها",
			"counties" : "بخشها",
			"states" : "استان ها",
			"postal_codes:" : "کد پستی",
			"formats" : "فرمت ها",
			"map" : "نقشه",
			"neighborhood" : "محله",
			"near_me" : "جلسات نزدیک من را پیدا کن",
			"text_search" : "جلسات اینجا را پیدا کن",
			"click_search" : "پیدا کردن جلسات نزدیک به یک نقطه روی نقشه",
			"pan_and_zoom" : "حرکت + بزرگنمایی",
			"languages" : "زبانها",
			"common_needs" : "خصوصیات مشترک",
			"meeting_count" : "جلسات هفتگی:",
			"venue_types" : "انواع مکان",
			"venue_type_choices" : {
				"IN_PERSON" : "حضوری",
				"VIRTUAL" : "لینک جلسه مجازی",
			},
			"service_body_types": {
				"AS" : "کمیته خدمات ناحیه",
				"RS" : "کمیته خدمات منطقه‌ای",
				"ZF" : "انجمن منطقه‌ای",
				"MA" : "کمیته خدمات کلان‌شهریe",
				"LS" : "انجمن خدمات محلی",
				"GS" : "انجمن پشتیبانی گروه",
			},
			"share" : "اشتراک گذاری",
			"google_directions" : "مسیرهای Google به جلسه",
			"apple_directions" : "مسیرهای Apple به جلسه",
			"no_meetings_for_this_day" : "هیچ جلسه ای در این روز وجود ندارد",
			"css-direction: bmlt-rtl" : "",
			"bootstrap-popover-placement" : "left",
			"adjust search" : "تنظیم جستجو",
			"this number represents" : "این عدد نشان دهنده",
			"radius of search in $$" : "شعاع جستجو بر حسب $$",
			"miles" : "مایل",
			"km" : "کیلومتر",
			"approx. number of meetings in result" : "تعداد تقریبی جلسات در نتیجه",
			"back" : "بازگشت",
			"all" : "همه",
			"menu" : " منوی",
			"search for meetings" : "جستجوی جلسه ها",
			"show meetings near..." : "نمایش جلسات نزدیک",
			"filter meetings" : "فیلتر جلسات",
			"visible meeting list" : "جلسات قابل مشاهده به عنوان لیست",
			"enter a city or zip code" : "شهر یا کد پستی را وارد کنید",
			"toggle fullscreen mode" : "تغییر حالت تمام صفحه",
			"close" : "بستن",
			"bmlt2ics" : "به تقویم خود اضافه کنید",
			"meeting page" : "صفحه جلسه",
			"meeting details" : "جزئیات جلسه",
			"report update" : "گزارش به‌روزرسانی",
			"filter by visibility" : "فقط این جلسات را فهرست کنید",
			"go" : "برو",
			"distance" : "فاصله",
			"get_directions" : "دریافت مسیر",
			"select_map_app" : "انتخاب برنامه نقشه",
			"apple_maps" : "نقشه اپل",
			"apple_maps_desc" : "باز کردن در برنامه نقشه اپل",
			"google_maps" : "گوگل مپس",
			"google_maps_desc_mobile" : "باز کردن در برنامه گوگل مپس",
			"waze" : "ویوز",
			"waze_desc" : "باز کردن در برنامه ویز",
			"sorted by distance" : "مرتب کردن بر اساس فاصله",
			"more info" : "اطلاعات بیشتر",
			"css-direction": 'bmlt-rtl',
			"css-textalign": "style='text-align: right;'",
			'address': 'آدرس',
			'meeting info': 'ویژگی',
			'comments': 'توضیحات',
			'group details': 'نمایش گروه',
			"address_lookup_fail": "آدرس پیدا نشد. لطفا دوباره تلاش کنید.",
		},
		"fr-CA": {
			"days_of_the_week" : ["", "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
			"weekday" : "Journée",
			"city" : "Ville",
			"cities" : "Villes",
			"groups" : "Groupes",
			"areas" : "ASL",
			"regions": "Regions",
			"locations" : "Emplacements",
			"counties" : "Régions",
			"states" : "Provinces",
			"postal_codes" : "Codes postaux",
			"formats" : "Formats",
			"map" : "Carte",
			"neighborhood": "Quartier",
			"near_me": "À côté de moi",
			"text_search": "Recherche textuelle",
			"click_search": "Recherche au clic",
			"pan_and_zoom": "Panoramique + Zoom",
			"languages": "Langages",
			"common_needs": "Besoins",
			"meeting_count": "Nombre de réunions par semaine",
			"venue_types": "Types de lieux",
			"venue_type_choices": {
				IN_PERSON: "Physique",
				VIRTUAL: "Virtuel",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "Partager",
			"google_directions": "Itinéraire sur Google Maps",
			'apple_directions': 'Itinéraire sur Apple Maps',
			"no_meetings_for_this_day": "Pas de réunion aujourd'hui.",
			"css-textalign": "",
			"css-floatdirection": "css-floatdirection",
			"all": "Tout",
			"menu": "Menu",
			"search for meetings": "Rechercher des réunions",
			"show meetings near...": "Afficher les réunions près de...",
			"filter meetings": "Filtrer les réunions",
			"visible meeting list": "Liste des réunions visibles",
			"enter a city or zip code": "Entrer une ville ou un code postal",
			"toggle fullscreen mode": "Basculer en mode plein écran",
			"close": "Fermer",
			"bmlt2ics": "Ajouter au calendrier",
			"meeting page": "Page de la réunion",
			"meeting details": "Détails de la réunion",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"distance": "Distance",
			"get_directions": "Obtenir l'itinéraire",
			"select_map_app": "Sélectionner l'application de cartes",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Ouvrir dans l'application Apple Maps",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Ouvrir dans l'application Google Maps",
			"waze": "Waze",
			"waze_desc": "Ouvrir dans l'application Waze",
			"sorted by distance": "Trié par distance",
			"address_lookup_fail": "L'adresse est introuvable. Veuillez réessayer.",
		},
		"it-IT": {
			"days_of_the_week" : ["", "Domenica", " Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
			"weekday" : "Giorno",
			"city" : "Città",
			"cities" : "Città",
			"groups" : "Gruppi",
			"areas" : "Aree",
			"regions": "Regione",
			"locations" : "Località",
			"counties" : "Province",
			"states" : "Regione",
			"postal_codes" : "CAP",
			"formats" : "Formati",
			"map" : "Mappa",
			"neighborhood": "Quartiere",
			"near_me": "Vicino a me",
			"text_search": "Ricerca testuale",
			"click_search": "Fare click su cerca",
			"pan_and_zoom": "Panoramica e zoom",
			"languages": "Lingue",
			"common_needs": "Bisogni comuni",
			"meeting_count": "Incontri settimanali:",
			"venue_types": "Tipologia di locali",
			"venue_type_choices": {
				IN_PERSON: "Riunione fisica",
				VIRTUAL: "Riunione virtuale",
			},
			"service_body_types": {
				AS: "Comitato area",
				RS: "Comitato di regione",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Forum supporto gruppi"
			},
			"share": "Condividi",
			'google_directions': 'Mappa',
			'apple_directions': 'Mappa',
			"no_meetings_for_this_day": "Nessuna riunione per questo giorno.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'Tutti',
			'menu': "Menu",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Mostra incontri nelle vicinanze..',
			'filter meetings': 'Filtrare le riunioni',
			'visible meeting list': 'Elenco riunioni visibile',
			'enter a city or zip code': 'Inserire una città o un codice postale',
			'toggle fullscreen mode': 'Attiva/disattiva la modalità a schermo intero',
			'close': "Close",
			"bmlt2ics": "Aggiungi al tuo calendario",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"distance": "Distanza",
			"get_directions": "Ottieni Indicazioni",
			"select_map_app": "Seleziona App Mappe",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Apri nell'app Apple Maps",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Apri nell'app Google Maps",
			"waze": "Waze",
			"waze_desc": "Apri nell'app Waze",
			"sorted by distance": "Ordinati per distanza",
			"address_lookup_fail": "L'indirizzo non è stato trovato. Per favore riprova.",
		},
		"nl-NL": {
			"days_of_the_week" : ["", "Zondag", "Maandag", "Dinsdag", "Woensdag", "Donderdag", "Vrijdag", "Zaterdag"],
			"weekday" : "Dag van de week",
			"city" : "Stad",
			"cities" : "Steden",
			"groups" : "Groepen",
			"areas" : "Gebieden",
			"regions": "Regions",
			"locations" : "Locaties",
			"counties" : "Landen",
			"states" : "Provincies",
			"postal_codes" : "Postcodes",
			"formats" : "Formats",
			"map" : "Kaart",
			"neighborhood": "Buurt",
			"near_me": "Bij mij in de buurt",
			"text_search": "Zoek op tekst",
			"click_search": "Klik om te zoeken",
			"pan_and_zoom": "Pan + Zoom",
			"languages": "Talen",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Soorten locaties",
			"venue_type_choices": {
				IN_PERSON: "Fysiek",
				VIRTUAL: "Online",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': "Menu",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			"bmlt2ics": "Add to your calendar",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"get_directions": "Routebeschrijving",
			"select_map_app": "Kies Kaart App",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Openen in Apple Maps app",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Openen in Google Maps app",
			"waze": "Waze",
			"waze_desc": "Openen in Waze app",
			"sorted by distance": "Gesorteerd op afstand",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"pl-PL": {
			"days_of_the_week" : ["", "Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
			"weekday" : "Dzień tygodnia",
			"city" : "Miasto",
			"cities" : "Miasta",
			"groups" : "Grupy",
			"areas" : "Okręgi",
			"regions": "Regions",
			"locations" : "Lokalizacje",
			"counties" : "Powiaty",
			"states" : "Województwa",
			"postal_codes" : "Kody pocztowe",
			"formats" : "Formaty",
			"map" : "Mapa",
			"neighborhood": "Sąsiedztwo",
			"near_me": "Blisko Mnie",
			"text_search": "Wpisz",
			"click_search": "Kliknij na mapie",
			"pan_and_zoom": "Przesuń powiększ",
			"languages": "Języki",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': "Menu",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			"bmlt2ics": "Add to your calendar",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"distance": "Odległość",
			"get_directions": "Pobierz Wskazówki",
			"select_map_app": "Wybierz Aplikację Map",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Otwórz w aplikacji Apple Maps",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Otwórz w aplikacji Google Maps",
			"waze": "Waze",
			"waze_desc": "Otwórz w aplikacji Waze",
			"sorted by distance": "Posortowane według odległości",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"pt-BR": {
			"days_of_the_week" : ["", "Domingo", "Segunda-feira", "Terça-feira", "Quarta-feira", "Quinta-feira", "Sexta-feira", "Sábado"],
			"weekday" : "Dia da semana",
			"city" : "Cidade",
			"cities" : "Cidades",
			"groups" : "Grupos",
			"areas" : "Áreas",
			"regions": "Regions",
			"locations" : "Localizações",
			"counties" : "Municípios",
			"states" : "Estados",
			"postal_codes" : "CEPs",
			"formats" : "Formatos",
			"map" : "Mapa",
			"neighborhood": "Bairro",
			"near_me": "Minha Localização",
			"text_search": "digite um endereço",
			"click_search": "Clique no local",
			"pan_and_zoom": "Panorâmico + Zoom",
			"languages": "Idiomas",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "tipos de reunião",
			"venue_type_choices": {
				IN_PERSON: "Presencial",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "Compartilhar",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': "Menu",
			"bmlt2ics": "Add to your calendar",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"distance": "Distância",
			"get_directions": "Obter Direções",
			"select_map_app": "Selecionar Aplicativo de Mapas",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Abrir no aplicativo Apple Maps",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Abrir no aplicativo Google Maps",
			"waze": "Waze",
			"waze_desc": "Abrir no aplicativo Waze",
			"sorted by distance": "Classificado por distância",
			"address_lookup_fail": "The address could not be found. Please try again.",
		},
		"ru-RU": {
			"days_of_the_week" : ["", "Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
			"weekday" : "будний день",
			"city" : "Город",
			"cities" : "Города",
			"groups" : "Группы",
			"areas" : "Зоны",
			"regions": "Regions",
			"locations" : "Локации",
			"counties" : "Страны",
			"states" : "Штаты",
			"postal_codes" : "Индексы (почтовые)",
			"formats" : "Форматы",
			"map" : "Карта",
			"neighborhood": "Соседство",
			"near_me": "Около меня",
			"text_search": "Поиск текста",
			"click_search": "Нажмите Поиск",
			"pan_and_zoom": "Pan + Zoom",
			"languages": "Языки",
			"common_needs": "Common Needs",
			"meeting_count": "Еженедельные собрания:",
			"venue_types": "Типы собрания",
            "venue_type_choices": {
                IN_PERSON: "Офлайн",
                VIRTUAL: "Онлайн",
            },
            "share": "поделиться",
			'google_directions': 'На карте',
			'apple_directions': 'На карте',
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"no_meetings_for_this_day": "В этот день собраний нет",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': "Меню",
			"bmlt2ics": "Добавить в календарь",
			'search for meetings': 'Поиск собраний',
			'show meetings near...': 'Показывать собрания рядом с...',
			'filter meetings': 'Фильтровать собрания',
			'visible meeting list': 'Собрания в виде списка',
			'enter a city or zip code': 'Введите город или почтовый индек',
			'toggle fullscreen mode': 'Включить полноэкранный режим',
			'close': "Закрыть",
			'meeting page': "Страница собрания",
			'meeting details': "Подробности собрания",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"distance": "Расстояние",
			"get_directions": "Проложить маршрут",
			"select_map_app": "Выбрать приложение карт",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Открыть в приложении Apple Maps",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Открыть в приложении Google Maps",
			"waze": "Waze",
			"waze_desc": "Открыть в приложении Waze",
			"sorted by distance": "Сортировка по расстоянию",
			"address_lookup_fail": "Адрес не найден. Пожалуйста, попробуйте еще раз.",
		},
		"sk": {
			"days_of_the_week": ["", "Nedeľa", "Pondelok", "Utorok", "Streda", "Štvrtok", "Piatok", "Sobota"],
			"weekday": "Deň v týždni",
			"city": "Mesto",
			"cities": "Mesto",
			"groups": "Skupina",
			"areas": "Oblasti",
			"regions": "Región",
			"locations": "Miesto",
			"counties": "Okres",
			"states": "Spolkové krajiny",
			"postal_codes": "PSČ",
			"formats": "Formáty",
			"map": "Mapa",
			"neighborhood": "Susedstvo",
			"near_me": "V mojej blízkosti",
			"text_search": "Textové vyhľadávanie",
			"click_search": "Vyhľadávanie kliknutím",
			"pan_and_zoom": "Posúvanie + Zoomovanie",
			"languages": "Jazek",
			"common_needs": "Bežné potreby",
			"meeting_count": "Týždenné stretnutia:",
			"venue_types": "Typy miest stretnutí",
			"venue_type_choices": {
				"IN_PERSON": "Osobné stretnutia",
				"VIRTUAL": "Živé stretnutia"
			},
			"service_body_types": {
			},
			"share": "Zdieľať",
			"google_directions": "Plánovač trás Google",
			"apple_directions": "Plánovač trás Apple",
			"no_meetings_for_this_day": "Žiadne stretnutia v tento deň.",
			"css-textalign": "",
			"css-floatdirection": "",
			"all": "Akékoľvek",
			"menu": "Menu",
			"search for meetings": "Hľadať stretnutia",
			"show meetings near...": "Stretnutia v iných mestách",
			"filter meetings": "Filter pre jazyk, formát atď.",
			"visible meeting list": "Viditeľné stretnutia ako tabuľka",
			"enter a city or zip code": "Mesto alebo PSČ",
			"toggle fullscreen mode": "Prepnúť režim celej obrazovky",
			"close": "Zavrieť",
			"bmlt2ics": "Pridať do kalendára",
			"meeting page": "Stránka stretnutia",
			"meeting details": "Podrobnosti o stretnutí",
			"report update": "Nahlásiť aktualizáciu",
			"filter by visibility": "Zobraziť iba stretnutia, ktoré sú práve na mape",
			"go": "Ísť!",
			"get_directions": "Získať trasu",
			"select_map_app": "Vyberte aplikáciu pre mapy",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Otvoriť v aplikácii Apple Maps",
			"google_maps": "Google Maps",
			"distance": "Vzdialenosť",
			"google_maps_desc_mobile": "Otvoriť v aplikácii Google Maps",
			"waze": "Waze",
			"waze_desc": "Otvoriť v aplikácii Waze",
			"remember my choice": "Zapamätať si moju voľbu",
			"zoomed-out-message": "Nemôžeme prehľadať celú oblasť pre stretnutia. Prosím, priblížte alebo vykonajte nové vyhľadávanie.",
			"sorted by distance": "Zoradené podľa vzdialenosti",
			"address_lookup_fail": "Adresa sa nenašla. Skúste to znova prosím.",
		},
		"sv-SE": {
			"days_of_the_week" : ["", "Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"],
			"weekday" : "Veckodag",
			"city" : "Stad",
			"cities" : "Städer",
			"groups" : "Grupper",
			"areas" : "Distrikt",
			"regions": "Regions",
			"locations" : "Plats",
			"counties" : "Land",
			"states" : "Stater",
			"postal_codes" : "Postnummer",
			"formats" : "Format",
			"map" : "Karta",
			"neighborhood": "Region",
			"near_me": "Nära mig",
			"text_search": "Söktext",
			"click_search": "Sök",
			"pan_and_zoom": "Panorera + Zooma",
			"languages": "Språk",
			"common_needs": "Common Needs",
			"meeting_count": "Weekly Meetings:",
			"venue_types": "Venue Types",
			"venue_type_choices": {
				IN_PERSON: "In Person",
				VIRTUAL: "Virtual",
			},
			"service_body_types": {
				AS: "Area Service Committee",
				RS: "Regional Service Committee",
				ZF: "Zonal Forum",
				MA: "Metropolitan Service Committee",
				LS: "Local Service Forum",
				GS: "Group Support Forum"
			},
			"share": "share",
			'google_directions': 'Google directions to meeting',
			'apple_directions': 'Apple directions to meeting',
			"no_meetings_for_this_day": "No meetings for this day.",
			'css-textalign': '',
			'css-floatdirection': '',
			'all': 'All',
			'menu': "Menu",
			'search for meetings': 'Search for meetings',
			'show meetings near...': 'Show meetings near...',
			'filter meetings': 'Filter meetings',
			'visible meeting list': 'Visible meetings as list',
			'enter a city or zip code': 'Enter a city or zip code',
			'toggle fullscreen mode': 'Toggle fullscreen mode',
			'close': "Close",
			"bmlt2ics": "Add to your calendar",
			'meeting page': "Meeting Page",
			'meeting details': "Meeting Details",
			'report update': "Report an Update",
			'filter by visibility': "List only these meetings",
			'go': "Go!",
			"get_directions": "Få vägbeskrivning",
			"select_map_app": "Välj kartapp",
			"apple_maps": "Apple Maps",
			"apple_maps_desc": "Öppna i Apple Maps-appen",
			"google_maps": "Google Maps",
			"google_maps_desc_mobile": "Öppna i Google Maps-appen",
			"waze": "Waze",
			"waze_desc": "Öppna i Waze-appen",
			"sorted by distance": "Sorterade efter avstånd",
			"address_lookup_fail": "The address could not be found. Please try again.",
		}
	};
}

CroutonLocalization.prototype.getDayOfTheWeekWord = function(day_id) {
	return this.words[this.language]['days_of_the_week'][day_id];
};

CroutonLocalization.prototype.getWord = function(word) {
	const ret = this.words[this.language][word.toLowerCase()];
	if (typeof ret === 'undefined') {
		if (word === 'css-direction') return '';
		if (word === 'bootstrap-popover-placement') return 'right';
		return word;
	}
	return ret;
};

CroutonLocalization.prototype.getVenueType = function(type) {
	return this.words[this.language]['venue_type_choices'][type];
}

CroutonLocalization.prototype.getServiceBodyType = function(type) {
	return this.words[this.language]['service_body_types'][type];
}
